import { FloatButton, Image } from "antd";
import cs from "../../images/cs.png";
import "./style.scss";

const CsFloatButton = ({ onClick }) => {
  return (
    <div className="sign-in-float-button">
      <FloatButton.Group
        shape="circle"
        style={{
          insetInlineEnd: 24,
        }}
      >
        <FloatButton
          icon={<Image src={cs} alt="cs" preview={false} className="cs-img" />}
          className="cs-float-btn"
          onClick={onClick}
        />
      </FloatButton.Group>
    </div>
  );
};

export default CsFloatButton;
